import { useQuery } from "@tanstack/react-query";
import { postsService, type PostsFiltersRequest, type PostsFiltersResponse } from "@/services/posts.service";

export const useStashesFilters = (
  params: PostsFiltersRequest = {},
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const queryKey = ["stashes", "filters", params.date_from ?? null, params.date_to ?? null];

  return useQuery<PostsFiltersResponse>({
    queryKey,
    queryFn: async () => postsService.getFilters(params),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export default useStashesFilters;
